module.exports = __webpack_public_path__ + "img/ptp1.0b2d41b1.jpg";